import script from "./ModalError.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalError.vue?vue&type=script&setup=true&lang=js"

import "./ModalError.vue?vue&type=style&index=0&id=c79e982e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c79e982e"]])

export default __exports__